"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArmpitLiftUpBlock = void 0;
const spa_core_1 = require("@episerver/spa-core");
const react_1 = __importDefault(require("react"));
const ArmpitLiftUpBlock = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const styles = {};
    if (((_a = props.data.backgroundColor) === null || _a === void 0 ? void 0 : _a.value) && props.data.backgroundColor.value !== '')
        styles.backgroundColor = props.data.backgroundColor.value;
    const isdark = ((_b = props.data.backgroundColor) === null || _b === void 0 ? void 0 : _b.value) === '#222836';
    const linkVar = {
        renderAsListElement: true, listItemClass: 'col-12'
    };
    let cssClasses = ['px-9 py-8', (_c = props.data.fontColor) === null || _c === void 0 ? void 0 : _c.value, (_d = props.data.bottomPadding) === null || _d === void 0 ? void 0 : _d.value, (_e = props.data.topPadding) === null || _e === void 0 ? void 0 : _e.value];
    return react_1.default.createElement("div", { className: 'py-8 py-sm-0' },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", Object.assign({ className: 'armpitLiftUpBlock', style: styles, "data-glenabled": (_f = props.data.enableGlossary) === null || _f === void 0 ? void 0 : _f.value }, (((_g = props.data.blockLanguage) === null || _g === void 0 ? void 0 : _g.value) !== '' ? { lang: (_h = props.data.blockLanguage) === null || _h === void 0 ? void 0 : _h.value } : null)),
                react_1.default.createElement("div", { className: `${cssClasses.join(' ')}` },
                    react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.data, field: "headingArea" }),
                    react_1.default.createElement("ul", { className: `row ${isdark ? 'dark' : ''}` },
                        react_1.default.createElement(spa_core_1.Components.ContentArea, { data: props.data.linkContentArea, noWrap: true, parentVar: linkVar }))))));
};
exports.ArmpitLiftUpBlock = ArmpitLiftUpBlock;
exports.default = exports.ArmpitLiftUpBlock;
